import { Component, Input, OnChanges } from '@angular/core';
import { ROW_ACTIONS, RowActionName, RowActionVariant } from '../../design/row-actions';
import { MenuAction } from '../action-menu/action-menu.component';

export function hasPermission(entity: string, action: string): boolean {
  const key = entity.replace(/_/g, '').toUpperCase();
  const entities = (window.localStorage.getItem('entities') || '').split(',');
  const permissions = JSON.parse(window.localStorage.getItem('permissions') || '{}');
  return entities.includes(key) && !!permissions[key]?.includes(action.toLowerCase());
}

export interface RowMenuItem {
  action?: RowActionName;
  label?: string;
  icon?: string;
  tone?: RowActionVariant;
  permission?: { entity: string; action: string };
  disabled?: boolean;
  hidden?: boolean;
  separator?: boolean;
  handler: () => void;
}

@Component({
  selector: 'ss-row-actions-menu',
  template: `
    <ss-action-menu *ngIf="menuItems.length" [items]="menuItems" [title]="title" (actionSelected)="run($event)"></ss-action-menu>
  `,
  standalone: false
})
export class RowActionsMenuComponent implements OnChanges {
  @Input() items: RowMenuItem[] = [];
  @Input() title = ROW_ACTIONS.more.title;

  menuItems: MenuAction[] = [];
  private visible: RowMenuItem[] = [];

  ngOnChanges() {
    this.visible = this.items.filter(item =>
      !item.hidden && (!item.permission || hasPermission(item.permission.entity, item.permission.action)));
    this.menuItems = this.visible.map((item, index) => ({
      id: String(index),
      label: item.label || (item.action ? ROW_ACTIONS[item.action].title : ''),
      action: item.action,
      icon: item.icon,
      tone: item.tone,
      disabled: item.disabled,
      separator: item.separator && index > 0
    }));
  }

  run(id: string) {
    this.visible[Number(id)]?.handler();
  }
}
